import React from "react";
import {
  formatDayLabel,
  formatTime,
  getDisplayLabel,
  getExceptionReason,
  getRowCity,
  isExceptionStatus,
  toSentence,
} from "./trackingUtils";

/** Group timeline rows by calendar day, keeping newest-first order. */
const groupByDay = (timeline) => {
  const groups = [];
  timeline.forEach((status, idx) => {
    const label = formatDayLabel(status.statusTimestamp);
    const last = groups[groups.length - 1];
    if (last && last.label === label) last.items.push({ status, idx });
    else groups.push({ label, items: [{ status, idx }] });
  });
  return groups;
};

const ShipmentJourney = ({ timeline, tone, cityContext }) => (
  <section className="card journey">
    <h2 className="card-title">Shipment Journey</h2>

    {timeline.length === 0 ? (
      <p className="muted">No tracking information available yet.</p>
    ) : (
      groupByDay(timeline).map((group) => (
        <div key={group.label} className="journey-day">
          <div className="journey-day-label">{group.label}</div>
          <ol className="journey-list">
            {group.items.map(({ status, idx }) => {
              const city = getRowCity(timeline, idx, cityContext);
              const itemClass = [
                "journey-item",
                idx === 0 && `latest tone-${tone}`,
                isExceptionStatus(status) && "exception",
              ]
                .filter(Boolean)
                .join(" ");

              return (
                <li key={`${status.status}-${status.statusTimestamp}-${idx}`} className={itemClass}>
                  <span className="journey-dot" />
                  <div className="journey-text">
                    <div className="journey-title">{toSentence(getDisplayLabel(status))}</div>
                    <div className="journey-sub">
                      {formatTime(status.statusTimestamp)}
                      {city && <> · {city}</>}
                    </div>
                    {getExceptionReason(status) && (
                      <div className="journey-reason">
                        Reason: {getExceptionReason(status)}
                      </div>
                    )}
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      ))
    )}
  </section>
);

export default ShipmentJourney;
